import { personal_details } from '@flows/configs/shared/steps/personal_details'
import type { StepConfigParams } from '@flows/configs/types'
import type { DeepReadonly } from '@flows/configs/types/helperTypes'
import type { AnySteps } from '@flows/core/types/stepTypes'

import liability_address from './liability_address'
import liability_cancelled from './liability_cancelled'
import liability_damages from './liability_damages'
import liability_deductibles from './liability_deductibles'
import liability_drone from './liability_drone'
import liability_family from './liability_family'
import liability_instant from './liability_instant'
import liability_insurance_choice from './liability_insurance_choice'
import liability_previously_owned from './liability_previously_owned'
import liability_quote from './liability_quote'
import liability_zip from './liability_zip'
import renters_bundle_liability_instant from './renters_bundle_liability_instant'

const getLiabilityNxtSteps = (params: StepConfigParams) => {
  return {
    liability_family: liability_family(params),
    liability_zip: liability_zip(params),
    liability_deductibles: liability_deductibles(params),
    liability_drone: liability_drone(params),
    liability_previously_owned: liability_previously_owned(params),
    liability_damages: liability_damages(params),
    liability_cancelled: liability_cancelled(params),
    liability_quote: liability_quote(params),
    liability_insurance_choice: liability_insurance_choice(params),
    liability_address: liability_address(params),
    liability_instant: liability_instant(params),
    renters_bundle_liability_instant: renters_bundle_liability_instant(params),
    liability_personal_details: personal_details(params, {
      nextStep: 'underwriting_validation',
      translations: {
        title: 'sharedFlows_liabilityNxt:steps.liability.personal_details.title',
        birthdateLabel:
          'sharedFlows_liabilityNxt:steps.liability.personal_details.birthdate.input.label',
        marketingOptIn: 'sharedFlows_liabilityNxt:steps.liability.personal_details.marketingOptIn',
        minAgeError: 'sharedFlows_liabilityNxt:steps.liability.personal.errors.min_age',
        maxAgeError: 'sharedFlows_liabilityNxt:steps.liability.personal.errors.max_age',
      },
      policyPreviewConsent: {
        titleKey: 'sharedFlows_liabilityNxt:steps.liability.personal_details.policyPreview.title',
        textKey: 'sharedFlows_liabilityNxt:steps.liability.personal_details.policyPreview.text',
      },
    }),
  } as const satisfies DeepReadonly<AnySteps>
}

export default getLiabilityNxtSteps
